export const MB_FORMAT = 'MB';

export const MEGABYTES = 1048576;
